
<div class="file-loader-table">
  <div class="file-loader-table__content">
    <data-table
      :headers="headers"
      :items="filteredFiles"
      :loading="loading"
      :items-per-page="itemsPerPage"
      :item-class="getRowClass"
      class="elevation-0"
      :aria-label="'File loader jobs table'"
      :data-testid="'file-loader-table'"
      @click:row="handleRowClick"
    >
    <!-- Loading slot -->
    <template #progress>
      <v-progress-linear
        indeterminate
        color="primary"
        aria-live="polite"
        aria-label="Loading file loader data"
      />
    </template>

    <!-- Date/Time column -->
    <template #item.loadedDate="{ item }">
      <span class="text-body-2 table-cell-text">
        {{ formatDate(item.loadedDate, 'full') }}
      </span>
    </template>

    <!-- File Name column (stacked with file type) -->
    <template #item.fileName="{ item }">
      <table-cell-stacked
        :primary="extractFileName(item.fileName)"
        :secondary="item.fileType"
      />
    </template>

    <!-- Status column -->
    <template #item.loadStatus="{ item }">
      <div class="d-flex align-center justify-center">
        <status-badge
          :status="getDerivedStatus(item).label"
          :type="getDerivedStatus(item).type"
          :aria-label="`Status: ${getDerivedStatus(item).label}`"
        />
      </div>
    </template>

    <!-- Rows Accepted column -->
    <template #item.rowsAccepted="{ item }">
      <div class="d-flex align-center justify-center">
        <span
          class="text-body-2 font-weight-medium"
          :class="item.rowsAccepted > 0 ? 'success--text' : 'table-cell-text'"
        >
          {{ item.rowsAccepted.toLocaleString() }}
        </span>
      </div>
    </template>

    <!-- Rows Rejected column -->
    <template #item.rowsRejected="{ item }">
      <div class="d-flex align-center justify-center">
        <span
          class="text-body-2 font-weight-medium"
          :class="item.rowsRejected > 0 ? 'error--text' : 'table-cell-text'"
        >
          {{ item.rowsRejected.toLocaleString() }}
        </span>
      </div>
    </template>

    <!-- Submissions column -->
    <template #item.submissionsCreated="{ item }">
      <div class="d-flex align-center justify-center">
        <span class="text-body-2 table-cell-text">
          {{ item.submissionsCreated.toLocaleString() }}
        </span>
      </div>
    </template>

    <!-- Column header tooltips -->
    <template #header.submissionsCreated="{ header }">
      <div class="d-flex align-center justify-center">
        <span>{{ header.text }}</span>
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              x-small
              class="ml-1"
              color="grey"
              v-on="on"
            >
              mdi-information-outline
            </v-icon>
          </template>
          <span>
            Where multiple rows relate to the same individual, they are grouped into a single submission.
            This figure may differ from the total Rows Accepted.
          </span>
        </v-tooltip>
      </div>
    </template>
    <template #header.durationSeconds="{ header }">
      <div class="d-flex align-center justify-center">
        <span>{{ header.text }}</span>
        <v-tooltip left max-width="380">
          <template #activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              x-small
              class="ml-1"
              color="grey"
              v-on="on"
            >
              mdi-information-outline
            </v-icon>
          </template>
          <span>Time taken to load the file into the system only. This does not include downstream data processing time.</span>
        </v-tooltip>
      </div>
    </template>

    <!-- Duration column -->
    <template #item.durationSeconds="{ item }">
      <div class="d-flex align-center justify-center">
        <span class="text-body-2 table-cell-text">
          {{ formatDuration(item.durationSeconds) }}
        </span>
      </div>
    </template>

    <!-- Empty state -->
    <template #no-data>
      <div class="text-center py-8">
        <v-icon size="48" color="grey lighten-1">mdi-file-upload-outline</v-icon>
        <div class="text-h6 grey--text mt-4">No file loader jobs found</div>
        <div class="text-body-2 grey--text">File loader jobs will appear here once files are uploaded</div>
      </div>
    </template>
    </data-table>
  </div>
</div>
